<template>
    <teleport to="#modal">
        <Loading
            :visible="lista.loading"
        >
        </Loading>
        <Modal v-model:visible="show_detail" backdrop>
            <template v-slot:header>
                <h2 class="text-2xl font-bold">Dettaglio</h2>
            </template>
            <template v-slot:main>
                <p v-for="(v,k) in detail"><span class="font-bold">{{ k }}:</span> {{ v }}</p>
            </template>
            <template v-slot:footer>
                <div class="flex justify-between pt-3">
                    <NextButton variant="outline-secondary"
                                @click="show_detail =false"
                                class="py-2 px-4 w-full">
                        Chiudi
                    </NextButton>
                </div>
            </template>
        </Modal>
    </teleport>
    <div class="m-auto px-8 md:px-20 pb-8">
        <div class="max-w-screen-2xl m-auto pt-5">
            <h2 class="text-3xl font-bold mb-4">Costi timesheet: {{ lista.rows[0]?.nodo || '---' }}</h2>
            <div class="flex flex-col col-span-2 mb-2">
                <Field field_name="Cerca" @update:modelValue="lista.debounceSearch"
                       v-model="lista.search"
                       placeholder="Cerca"></Field>
            </div>

            <div class="flex justify-end">
                <Paginator class="" :pagination="lista.paginate"></Paginator>
            </div>

            <div class="rotate-x-180 overflow-x-scroll">
                <NextTable class="rotate-x-180 w-full border-separate border-spacing-3 py-4 table-fixed"
                           v-model:cols="cols"
                           :rows="lista.rows" @order-update="lista.updateCols">
                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_1`]="context">
                        {{ $filters.toEuroCurrency(c.TOTALE_COSTO) }}
                    </template>
                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_2`]="context">
                        <span @click="showData(c)"
                              class="text-center inset-0 absolute flex items-center justify-center"><i
                            class="icon-chevron_destra"></i></span>

                    </template>

                </NextTable>
            </div>

            <InfiniteLoading @infinite="lista.fetchNextPage"
                             :identifier="lista.infiniteIdentifier" style="min-height: 1px">
                <template #complete>
                    <div class="text-center pb-3">Non ci sono altre righe.</div>
                </template>
            </InfiniteLoading>
<!--            <table class="table-cost w-full border-separate border-spacing-3">-->
<!--                <thead>-->
<!--                <tr>-->
<!--                    <th>Totale ore</th>-->
<!--                    <th>Totale costo</th>-->
<!--                </tr>-->
<!--                </thead>-->
<!--                <tbody>-->
<!--                <tr v-for="c in costi_timesheet">-->
<!--                    <td class="p-2 text-sm relative bg-next-gray-md-dark">{{ c.TOTALE_ORE }}</td>-->
<!--                    <td class="p-2 text-sm relative bg-next-gray-md-dark">{{ $filters.toEuroCurrency(c.TOTALE_COSTO) }}</td>-->
<!--                </tr>-->

<!--                </tbody>-->
<!--            </table>-->

        </div>
    </div>
</template>

<script lang="ts">
import {Options, setup, Vue} from 'vue-class-component';
import sottoProgettiManager from "@/api/SottoProgetti";
import NextButton from "@/components/NextButton.vue";
import Modal from "@/components/Modal.vue";
import Loading from "@/components/Loading.vue";
import Field from "@/components/Field.vue";
import Paginator from "@/components/Paginator.vue";
import NextTable from "@/components/NextTable.vue";
import InfiniteLoading from "v3-infinite-loading";
import Lista from "@/setup/ListaCerca";

@Options({
    name: 'CostiTimesheetSottoprogetto',
    components: {NextTable, Paginator, Field, InfiniteLoading, Loading, Modal, NextButton},
    props: {
        id: [Number, String],
    },
    computed: {},
    methods: {}
})
export default class CostiTimesheetSottoprogetto extends Vue {
    lista: any = setup(() => Lista(sottoProgettiManager, this.cols, sottoProgettiManager.costiTimesheet));
    id!: string;
    show_detail = false
    detail = null

    created() {
        this.lista.callBinds = [this.id]
        this.lista.fetchData()
    }

    showData(data: any) {
        this.detail = data
        this.show_detail = true
    }

    cols = [
        {
            name: 'Totale ore',
            prop: 'TOTALE_ORE',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Totale costo',
            prop: 'TOTALE_COSTO',
            orderable: true,
            class: 'text-right whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: '',
            prop: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative bg-next-gray-md-dark hover:bg-next-orange hover:text-white',
            resizable: false
        }
    ]
}

</script>


<style lang="scss" scoped>
.table-costi-ricavi {
    td {
        @apply p-2 text-sm relative bg-next-gray-md-dark
    }
}
</style>
